import React from 'react';
import {FlipCard, Icon, Text} from '../../components/common';
import {colors} from '../../theme';
import {useScreenSize} from '../../utils/useScreenSize';
import {Person} from '../../types';
import {useCarouselNavigation} from '../../utils';
interface IMedicCarousel {
  medics: Person[];
  title: string;
  subtitle: string;
}

export const MedicCarousel = ({medics, title, subtitle}: IMedicCarousel) => {
  const screenSize = useScreenSize();

  const isLargeScreen =
    screenSize === 'large' ||
    screenSize === 'extra-large' ||
    screenSize === 'xx-large';
  const cardSize = isLargeScreen ? 30 : 21;

  const {
    currentSlideIndex,
    onGoToPreviousSlide,
    onGoToNextSlide,
    swipeHandlers,
  } = useCarouselNavigation({
    itemCount: medics.length,
    wrap: true,
    autoplayIntervalMs: 2900,
    externallyPaused: isLargeScreen,
  });

  return (
    <div
      className="md:flex ml-0 md:ml-10 lg:ml-28 xl:ml-40 2xl:ml-[10%] items-center"
      {...swipeHandlers}>
      <div className="md:min-w-[30rem] pr-8 ml-8 ">
        <h3 className="text-h3mob md:text-h2 font-title text-black">{title}</h3>
        <Text
          as="p"
          variant="LargeBody"
          className="text-black pt-5 md:pt-10 pb-10">
          {subtitle}
        </Text>
        <div className="hidden md:flex gap-6 ">
          <button onClick={onGoToPreviousSlide}>
            <Icon
              iconName={'left'}
              fill={colors.white}
              height={75}
              width={75}
            />
          </button>
          <button onClick={onGoToNextSlide}>
            <Icon
              iconName={'right'}
              fill={colors.white}
              height={75}
              width={75}
            />
          </button>
        </div>
      </div>
      <div className="overflow-hidden">
        <div
          className={`flex ml-6 gap-4 lg:gap-8 transition ease-out duration-500 h-[25rem] lg:h-[36rem] `}
          style={{
            transform: `translatex(-${currentSlideIndex * cardSize}rem)`,
          }}>
          {medics.map((medic, key) => {
            return (
              <div className="min-w-[20rem] lg:min-w-[28rem]" key={key}>
                <FlipCard
                  key={key}
                  image={medic.image}
                  name={medic.name}
                  description={medic.description}
                  pronouns={medic.pronouns}
                />
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};
